// extracted by extract-css-chunks-webpack-plugin
module.exports = {"modalWrapper":"Modal__modalWrapper___1hOKq","modalContent":"Modal__modalContent___2FDlS","modalContentFixedSize":"Modal__modalContentFixedSize___3SEqC"};
    if(module.hot) {
      // 1778083486242
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  